export const MIN_SUB_USECASES_TEMPLATES = 30;
export const MIN_USECASES_TEMPLATES = 50;

export const USECASE_LOGOS_SLUG = 'logos';
export const USECASE_ALL_SLUG = 'all';
export const MERCHANDISE_SLUG = 'merchandise';
